export const productDomain = 'gk.duyangsong.cn'
/**
 * 统一 API 响应结构
 */
export interface ApiResponse<T = any> {
  code: string
  msg: string
  data: T
}
export function isProduction() {
  return window.location.hostname === productDomain
}
const VITE_API_BASE_URL_PRODUCT = 'https://api.duyangsong.cn'
const VITE_API_BASE_URL_TEST =
  'https://gk-regir-docker-nvlgswjdem.cn-shenzhen.fcapp.run'
const depolyBaseURL = (() => {
  if (isProduction()) {
    return VITE_API_BASE_URL_PRODUCT
  }
  return VITE_API_BASE_URL_TEST
})()
// 开发环境使用 /api 代理，生产环境使用完整 URL
export const API_BASE_URL = import.meta.env.DEV ? '/api' : depolyBaseURL
/**
 * API 错误类
 */
export class ApiError extends Error {
  code: string
  msg: string

  constructor(code: string, msg: string) {
    super(msg)
    this.name = 'ApiError'
    this.code = code
    this.msg = msg
  }
}
export const apiConfig = {
  baseURL: API_BASE_URL, // 基础请求地址
  timeout: 20000, // 20 秒超时时间
  headers: {
    'Content-Type': 'application/json',
  },
}
